const DataTable = require('okCharts/DataTable');

module.exports = DataTable;
